// extracted by mini-css-extract-plugin
export default {"root":"VXfau","desktop":"MYr2A","card":"I0Df9","tablet":"a4aWj","cardContainer":"b9ZtZ","mobile":"c73aV","smallMobile":"VhCcA","shader":"T38me"};